<template>
  <BaseCommonPage>
  <div class="fun_container" v-bind:is="component">
    <!-- パンくずリスト -->
    <CreatePlusBreadcrumbs v-bind:categoryid="categoryid" v-bind:subcategoryid="subcategoryid" />
    <!-- /パンくずリスト -->
  
      <!-- トップ画像 -->
    <CreatePlusTemplateListTop v-bind:categoryid="categoryid" />
    <!-- / トップ画像 -->

    <!-- テンプレート一覧 -->
    <CreatePlusTemplateList v-bind:categoryid="categoryid" v-bind:subcategoryid="subcategoryid" />
    <!-- テンプレート一覧 -->
  </div>

  </BaseCommonPage>
</template>

<script>
import CreatePlusBreadcrumbs from '../components/CreatePlusBreadcrumbs'
import CreatePlusTemplateListTop from '../components/CreatePlusTemplateListTop'
import CreatePlusTemplateList from '../components/CreatePlusTemplateList'
import BaseCommonPage from "./BaseCommonPage";
import CreatePlusTop from "./CreatePlusTop";
export default {
  name: "CreatePlusBaseTemplateListPage",
  props: {
    categoryid: String,
    subcategoryid: String,
  },
  components: {
    CreatePlusBreadcrumbs,
    CreatePlusTemplateListTop,
    CreatePlusTemplateList,
    BaseCommonPage,
  },
  computed: {
    component: function() {
      const category = this.$store.state.createplusTemplates.createplusCategories.find((category) => {
        return category.categoryID === this.categoryid;
      });
      let subcategory = null;
      if (category) {
        subcategory = category.subCategories.find((subcategory) => {
          return subcategory.subCategoryID === this.subcategoryid;
        });
      }
      if (category && subcategory) {
        return "div";
      }
      return CreatePlusTop;
    }
  },
  metaInfo() {
    return {
      title: "Epson Setup Navi",
      meta: [
        {
          name: "description",
          content: this.$store.state.messages.messages["0-141"],
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href:
            process.env.VUE_APP_ROOT + "/assets/createplus/css/createplus.css",
        },
        {
          rel: "stylesheet",
          href: "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css",
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>